import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/FolderCard';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { gallectionTypeToResourceType } from '@wix/da-shared-react/pkg/types/gallection';
import { AppState } from '../../../../../types/store';
import { getSubfolders } from '../../../../selectors/folders';
import { setSelectedFolderId } from '../../../../actions/gallectionSection';
import {
  getSelectedFolderId,
  getFolderTotalDeviationCount,
} from '../../../../selectors/gallectionSection';

type StateProps = Pick<Props, 'subfolders'>;
type DispatchProps = Pick<Props, 'onClick'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const selectedFolderId = getSelectedFolderId(state);
  const folderTypeId = gallectionTypeToResourceType(ownProps.folder.type);
  return {
    isSelected:
      ownProps.folder && ownProps.folder.folderId === selectedFolderId,
    subfolders: getSubfolders(
      state,
      ownProps.folder && ownProps.folder.folderId
    ),
    totalDeviationCount: getFolderTotalDeviationCount(
      state,
      ownProps.folder.folderId
    ),
    contentClickBiData: {
      evid: BiEventType.ITEM_CLICK,
      view: 'profile',
      widgetname: 'folders',
      rank: ownProps.indexInsideParent,
      typeid: folderTypeId,
      itemid: ownProps.folder.folderId,
    },
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  onClick: () => {
    dispatch(setSelectedFolderId(ownProps.folder.folderId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
